import React, {Component} from "react";
import {connect} from "react-redux";
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import fetchWP from './utils/fetchWP';


import Toggle from 'react-toggle';
import ReactSelect from 'react-select';

import 'react-toggle/style.css';
// import style1 from './react-toggle.scss';
import style from './Settings.scss';

const AWRPLoader = () => (
    <div className={style.awcfe_loader} > </div>
);


var def = [{value: '', label: 'Select'}];
const extraFields_optionsBS = [...def, ...Object.keys(window.awcfe_object.extraFields_list_BS).map((key) => {
    return {value: window.awcfe_object.extraFields_list_BS[key]['id'], label: window.awcfe_object.extraFields_list_BS[key]['label']};
})];
const extraFields_options = [...def, ...Object.keys(window.awcfe_object.extraFields_list).map((key) => {
    return {value: window.awcfe_object.extraFields_list[key]['id'], label: window.awcfe_object.extraFields_list[key]['label']};
})];
const extraFields_optionsBill = [...def, ...Object.keys(window.awcfe_object.extraFields_list_billing).map((key) => {
    return {value: window.awcfe_object.extraFields_list_billing[key]['id'], label: window.awcfe_object.extraFields_list_billing[key]['label']};
})];
const extraFields_optionsShipp = [...def, ...Object.keys(window.awcfe_object.extraFields_list_shipping).map((key) => {
    return {value: window.awcfe_object.extraFields_list_shipping[key]['id'], label: window.awcfe_object.extraFields_list_shipping[key]['label']};
})];


const emailOptions = [
  { value: 'above', label: 'Above customer details' },
  { value: 'below', label: 'Below customer details' },
];


export default class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            awcfe_enablet_sec_head_email: false,
            awcfe_enablet_sec_head_odpage: false,
            awcfe_activation_status: false,
            awcfe_enablet_pdf_ip_support: false,
            awcfe_pdf_ip_invoice_fields: '',
            awcfe_pdf_ip_packing_fields: '',
            awcfe_activation_license_key: '',
            activation_message: '',
            awcfeLoader: true,
            isHidden: true,
            selectedOption: null,
            selectedOption1: null,
            selectedEmailPostn: null,
            awcfe_email_disp_postn_fields: 'above',
            awcfe_google_map_api_key: '',
            awcfe_address_format_custom: '',
            awcfe_order_table_fields: '',
            awcfe_addrextra_billing_fields: '',
            awcfe_addrextra_shipping_fields: '',

            ship_to_different_address: false,
            remove_order_notes_title: false,
            order_Notes_Title: '',
            force_create_Account : false,
            privacy_text : false,
            checkout_coupon_form : false,
            remove_shipping_field : false,
            remove_terms_condition :false,

            awcfe_enable_aco_pdf_support: false,
            awcfe_aco_pdf_invoice: '',
            awcfe_aco_pdf_packing: '',
            awcfe_aco_pdf_shipping: '',
            awcfe_aco_pdf_delivery: '',
            awcfe_aco_pdf_dispatch: '',
            awcfe_aco_pdf_credit: '',
        }

        this.handleInput = this.handleInput.bind(this);
        this.handleActivation = this.handleActivation.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);

        this.fetchWP = new fetchWP({
            restURL: window.awcfe_object.root,
            restNonce: window.awcfe_object.api_nonce,
        });

    }

    componentDidMount() {
        this.fetchWP.get('awcfe_settings/1')
            .then(
                (json) => {
                    // console.log(json);
                    this.setState({
                        awcfeLoader: false,
                        awcfe_email_disp_postn_fields: (json.awcfe_email_disp_postn_fields) ? json.awcfe_email_disp_postn_fields : 'above',
                        awcfe_activation_license_key: (json.awcfe_license_key) ? json.awcfe_license_key : '',
                        awcfe_activation_status: (json.awcfe_license_status) ? json.awcfe_license_status : false,
                        awcfe_enablet_sec_head_email: (json.awcfe_enablet_sec_head_email ) ? json.awcfe_enablet_sec_head_email : false,
                        awcfe_enablet_sec_head_odpage: (json.awcfe_enablet_sec_head_odpage ) ? json.awcfe_enablet_sec_head_odpage : false,
                        awcfe_enablet_pdf_ip_support: (json.awcfe_enablet_pdf_ip_support ) ? json.awcfe_enablet_pdf_ip_support : false,
                        awcfe_pdf_ip_invoice_fields: (json.awcfe_pdf_ip_invoice_fields ) ? json.awcfe_pdf_ip_invoice_fields : '',
                        awcfe_pdf_ip_packing_fields: (json.awcfe_pdf_ip_packing_fields ) ? json.awcfe_pdf_ip_packing_fields : '',
                        awcfe_google_map_api_key: (json.awcfe_google_map_api_key ) ? json.awcfe_google_map_api_key : '',
                        awcfe_address_format_custom: (json.awcfe_address_format_custom ) ? json.awcfe_address_format_custom : '',
                        awcfe_order_table_fields: (json.awcfe_order_table_fields ) ? json.awcfe_order_table_fields : '',
                        awcfe_addrextra_billing_fields: (json.awcfe_addrextra_billing_fields ) ? json.awcfe_addrextra_billing_fields : '',
                        awcfe_addrextra_shipping_fields: (json.awcfe_addrextra_shipping_fields ) ? json.awcfe_addrextra_shipping_fields : '',

                        awcfe_enable_aco_pdf_support: (json.awcfe_aco_pdf.enable ) ? json.awcfe_aco_pdf.enable : false,
                        awcfe_aco_pdf_invoice: (json.awcfe_aco_pdf.invoice ) ? json.awcfe_aco_pdf.invoice : '',
                        awcfe_aco_pdf_packing: (json.awcfe_aco_pdf.packing ) ? json.awcfe_aco_pdf.packing : '',
                        awcfe_aco_pdf_shipping: (json.awcfe_aco_pdf.shipping ) ? json.awcfe_aco_pdf.shipping : '',
                        awcfe_aco_pdf_delivery: (json.awcfe_aco_pdf.delivery ) ? json.awcfe_aco_pdf.delivery : '',
                        awcfe_aco_pdf_dispatch: (json.awcfe_aco_pdf.dispatch ) ? json.awcfe_aco_pdf.dispatch : '',
                        awcfe_aco_pdf_credit: (json.awcfe_aco_pdf.credit ) ? json.awcfe_aco_pdf.credit : '',

                        ship_to_different_address: (json.ship_to_different_address) ? json.ship_to_different_address :false,
                        remove_order_notes_title: (json.remove_order_notes_title) ? json.remove_order_notes_title :false,
                        order_Notes_Title: (json.order_Notes_Title) ? json.order_Notes_Title : '',
                        force_create_Account: (json.force_create_Account) ? json.force_create_Account :false,
                        privacy_text: (json. privacy_text) ? json. privacy_text :false,
                        checkout_coupon_form :  (json.checkout_coupon_form) ? json. checkout_coupon_form :false,
                        remove_shipping_field :  (json.remove_shipping_field) ? json.remove_shipping_field :false,
                        remove_terms_condition :(json.remove_terms_condition) ? json.remove_terms_condition :false,
                    });
                }
            );
    };


    handleInput(e) {
        let value = e.target.value;
        let name = e.target.name;
        if ( name == "awcfe_activation_license_key" ) {
            this.setState({
                [name]: value,
                awcfe_license_status: true
            })
        } else {
            this.setState({
                [name]: value
            })
        }
    }



    handleFormSubmit(e) {
        e.preventDefault();
        let data = this.state;
        this.setState({
            isHidden: false
        });
        this.fetchWP.post('awcfe_settings', data)
            .then(
                (json) => {  //console.log(json);
                    this.setState({
                        awcfe_enablet_sec_head_email: (json.awcfe_enablet_sec_head_email == 1) ? true : false,
                        awcfe_enablet_sec_head_odpage: (json.awcfe_enablet_sec_head_odpage == 1) ? true : false,
                        awcfe_enablet_pdf_ip_support: (json.awcfe_enablet_pdf_ip_support == 1) ? true : false,
                        awcfe_pdf_ip_invoice_fields: (json.awcfe_pdf_ip_invoice_fields) ? json.awcfe_pdf_ip_invoice_fields : '',
                        awcfe_pdf_ip_packing_fields: (json.awcfe_pdf_ip_packing_fields) ? json.awcfe_pdf_ip_packing_fields : '',
                        awcfe_email_disp_postn_fields: (json.awcfe_email_disp_postn_fields) ? json.awcfe_email_disp_postn_fields : '',
                        awcfe_google_map_api_key: (json.awcfe_google_map_api_key) ? json.awcfe_google_map_api_key : '',
                        awcfe_address_format_custom: (json.awcfe_address_format_custom) ? json.awcfe_address_format_custom : '',
                        awcfe_order_table_fields: (json.awcfe_order_table_fields) ? json.awcfe_order_table_fields : '',
                        awcfe_addrextra_billing_fields: (json.awcfe_addrextra_billing_fields) ? json.awcfe_addrextra_billing_fields : '',
                        awcfe_addrextra_shipping_fields: (json.awcfe_addrextra_shipping_fields) ? json.awcfe_addrextra_shipping_fields : '',

                        awcfe_enable_aco_pdf_support: (json.awcfe_aco_pdf.enable == 1) ? true : false,
                        awcfe_aco_pdf_invoice: (json.awcfe_aco_pdf.invoice) ? json.awcfe_aco_pdf.invoice : '',
                        awcfe_aco_pdf_packing: (json.awcfe_aco_pdf.packing) ? json.awcfe_aco_pdf.packing : '',
                        awcfe_aco_pdf_shipping: (json.awcfe_aco_pdf.shipping) ? json.awcfe_aco_pdf.shipping : '',
                        awcfe_aco_pdf_delivery: (json.awcfe_aco_pdf.delivery ) ? json.awcfe_aco_pdf.delivery : '',
                        awcfe_aco_pdf_dispatch: (json.awcfe_aco_pdf.dispatch ) ? json.awcfe_aco_pdf.dispatch : '',
                        awcfe_aco_pdf_credit: (json.awcfe_aco_pdf.credit ) ? json.awcfe_aco_pdf.credit : '',

                        ship_to_different_address: (json.ship_to_different_address == 1) ? true : false,
                        remove_order_notes_title: (json.remove_order_notes_title == 1) ? true : false,
                        order_Notes_Title: (json.order_Notes_Title) ? json.order_Notes_Title : '',
                        force_create_Account: (json.force_create_Account == 1) ? true : false,
                        privacy_text : (json.privacy_text == 1) ? true : false,
                        checkout_coupon_form : (json.checkout_coupon_form == 1) ? true : false ,
                        remove_shipping_field : (json. remove_shipping_field == 1) ? true : false,
                        remove_terms_condition :(json.remove_terms_condition == 1) ? true : false,

                        isHidden: true
                    });
                }
            );
    }


    handleStatusChange(e) {
        let value = e.target.checked;
        let name = e.target.name;
        this.setState({
            [name]: value,
        })
    }

    handleActivation(e) {
        e.preventDefault();
        let key = this.state.awcfe_activation_license_key;
        this.setState({
            isHidden: false
        });
        this.fetchWP.post('awcfe_activation', key)
            .then(
                (json) => {  // console.log(json);
                    this.setState({
                        activation_message: json.message,
                        isHidden: true,
                        awcfe_activation_status: ( json.status === 'valid' ) ? true : false,
                    });
                }
            );

    }

    handleChangeAI = selectedOption0 => {
      let selopts = [];
      let value = selectedOption0.map(e => {
        let  value1 = e.value;
        if(value1 != ''){
          selopts.push(value1);
        }
      })
	   //this.setState({ selopts });
     this.setState({ awcfe_aco_pdf_invoice: selopts });
    };

    handleChangeAP = selectedOption00 => {
      let selopts = [];
      let value = selectedOption00.map(e => {
        let  value1 = e.value;
        if(value1 != ''){
          selopts.push(value1);
        }
      })
	   //this.setState({ selopts });
     this.setState({ awcfe_aco_pdf_packing: selopts });
    };

    handleChangeAS = selectedOption01 => {
      let selopts = [];
      let value = selectedOption01.map(e => {
        let  value1 = e.value;
        if(value1 != ''){
          selopts.push(value1);
        }
      })
	   //this.setState({ selopts });
     this.setState({ awcfe_aco_pdf_shipping: selopts });
    };

    handleChangeAD = selectedOption01 => {
      let selopts = [];
      let value = selectedOption01.map(e => {
        let  value1 = e.value;
        if(value1 != ''){
          selopts.push(value1);
        }
      })
	   //this.setState({ selopts });
     this.setState({ awcfe_aco_pdf_delivery: selopts });
    };

    handleChangeADP = selectedOption01 => {
      let selopts = [];
      let value = selectedOption01.map(e => {
        let  value1 = e.value;
        if(value1 != ''){
          selopts.push(value1);
        }
      })
	   //this.setState({ selopts });
     this.setState({ awcfe_aco_pdf_dispatch: selopts });
    };

    handleChangeAC = selectedOption01 => {
      let selopts = [];
      let value = selectedOption01.map(e => {
        let  value1 = e.value;
        if(value1 != ''){
          selopts.push(value1);
        }
      })
	   //this.setState({ selopts });
     this.setState({ awcfe_aco_pdf_credit: selopts });
    };

    handleChange = selectedOption => {

      let selopts = [];
      let value = selectedOption.map(e => {
        let  value1 = e.value;
        if(value1 != ''){
          selopts.push(value1);
        }
      })
	   //this.setState({ selopts });
     this.setState({ awcfe_pdf_ip_invoice_fields: selopts });

    };

    handleChangePacking = selectedOption1 => {

      let selopts = [];
      let value = selectedOption1.map(e => {
        let  value1 = e.value;
        if(value1 != ''){
          selopts.push(value1);
        }
      })
	   //this.setState({ selopts });
     this.setState({ awcfe_pdf_ip_packing_fields: selopts });

    };

    handleChangeOrderTable = selectedOption1 => {
      let selopts = [];
      let value = selectedOption1.map(e => {
        let  value1 = e.value;
        if(value1 != ''){
          selopts.push(value1);
        }
      })
	   //this.setState({ selopts });
     this.setState({ awcfe_order_table_fields: selopts });

    };

    handleChangeAddrExtraBill = selectedOption1 => {
      let selopts = [];
      if (selectedOption1) { 
        selectedOption1.map(e => {
          let value1 = e.value;
          if (value1 !== '') { 
            selopts.push(value1);
          }
        });
      }
      this.setState({ awcfe_addrextra_billing_fields: selopts });
    };

    handleChangeAddrExtraShip = selectedOption1 => {
      let selopts = [];
      if (selectedOption1) { 
        selectedOption1.map(e => {
          let value1 = e.value;
          if (value1 !== '') { 
            selopts.push(value1);
          }
        });
      }
	   //this.setState({ selopts });
     this.setState({ awcfe_addrextra_shipping_fields: selopts });

    };

    handleChangeEmlPos = selectedEmailPostn => {
      //console.log(selectedEmailPostn.value);
      this.setState({ selectedEmailPostn });
      this.setState({ awcfe_email_disp_postn_fields: selectedEmailPostn.value });
    };

    render() {

      const { selectedOption, selectedOption1, selectedEmailPostn } = this.state;

        return (<div className={style.wrap}>
                <div className={style.container}>

                <div className={style.left_sec}>
                <div className={style.tab_wrap}>

                <Tabs className={style.react_tab} selectedTabClassName={style.tab_active}>
                    <TabList className={style.left_tab} >
                        <Tab className={style.left_tab_list} > {wp.i18n.__('General settings')} </Tab>
                        <Tab className={style.left_tab_list} > {wp.i18n.__('Advanced settings')} </Tab>
                        <Tab className={style.left_tab_list} > {wp.i18n.__('Address formatting')} </Tab>
                        <Tab className={style.left_tab_list} > {wp.i18n.__('PDF Invoices & Packing Slips By Acowebs')} </Tab>
                        <Tab className={style.left_tab_list} > {wp.i18n.__('PDF Invoices & Packing Slips for WooCommerce By WP Overnight')} </Tab>
                        <Tab className={style.left_tab_list} > {wp.i18n.__('License Key')} </Tab>
                        
                    </TabList>


                     {/* { console.log(this.state.awcfe_activation_status) } */}

                     <TabPanel className={style.right_tab} >
                      <div className={style.awcfe_field_group}>
                        <div className={style.text_group}>
                            <p className={style.sectionTitle}>{wp.i18n.__('General settings')}</p>
                        </div>

                        <div className={style.form_activation_group}>

                          <div className={style.form_item_group}>
                            <label className={style.form_label}>{wp.i18n.__('Google Map API Key')}</label>
                            <input
                                name ="awcfe_google_map_api_key"
                                type="text"
                                value={this.state.awcfe_google_map_api_key}
                                onChange={this.handleInput}
                                //placeholder="Enter your Google Map API Key here"
                                className={style.form_input}
                            />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Email Fields display position')}</label>
                              <ReactSelect
                                  className={style.form_select}
                                  options={emailOptions}
                                  name="awcfe_email_disp_postn_fields"
                                  placeholder="Select"
                                  value={emailOptions.filter(e =>  this.state.awcfe_email_disp_postn_fields.indexOf(e.value) >= 0 )}
                                  onChange={this.handleChangeEmlPos}
                              />

                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Disable section title/heading display in order Email.')}</label>

                              <Toggle
                                name={'awcfe_enablet_sec_head_email'}
                                icons={false}
                                value={this.state.awcfe_enablet_sec_head_email}
                                checked={this.state.awcfe_enablet_sec_head_email}
                                onChange={this.handleStatusChange}
                              />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Disable section title/heading display in order detail page.')}</label>

                              <Toggle
                                name={'awcfe_enablet_sec_head_odpage'}
                                icons={false}
                                value={this.state.awcfe_enablet_sec_head_odpage}
                                checked={this.state.awcfe_enablet_sec_head_odpage}
                                onChange={this.handleStatusChange}
                              />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Orders Table custom column')}</label>
                              <ReactSelect
                                  className={style.form_select}
                                  options={extraFields_options}
                                  name="awcfe_order_table_fields"
                                  placeholder="Select"
                                  isMulti
                                  value={extraFields_options.filter(e => Array.isArray(this.state.awcfe_order_table_fields) ? this.state.awcfe_order_table_fields.indexOf(e.value) >= 0 : false)}
                                  onChange={this.handleChangeOrderTable}
                              />
                            </div>

                            <div className={style.activate_license} >
                                <input
                                    type="button"
                                    value="Save"
                                    onClick ={this.handleFormSubmit}
                                    className={style.form_button}
                                />
                            </div>
                            {!this.state.isHidden && <AWRPLoader />}

                        </div>

                      </div>
                    </TabPanel>
                    
                    <TabPanel className={style.right_tab} >
                        <div className={style.awcfe_field_group}>
                            <div className={style.text_group}>
                                <p className={style.sectionTitle}>{wp.i18n.__('Advanced Settings')}</p>
                                </div>
                                <div className={style.form_activation_group}>
              
                                <div className={style.form_item_group}>
                                  <label className={style.form_label} title="Click to force a different shipping address">
                                    {wp.i18n.__('Force Shipping Address')}
                                  </label>                         
                                    <Toggle
                                        
                                        name={'ship_to_different_address'}
                                        icons={false}
                                        value={this.state.ship_to_different_address}
                                        checked={this.state.ship_to_different_address}
                                        onChange={this.handleStatusChange}
                                    /> 
                                </div>
                                <div className={style.form_item_group}>
                                    <label className={style.form_label} title="Removing the title of order notes in checkout">
                                      {wp.i18n.__('Remove Order Notes Title')}
                                    </label>
                                    <Toggle
                                        name={'remove_order_notes_title'}
                                        icons={false}
                                        value={this.state.remove_order_notes_title}
                                        checked={this.state.remove_order_notes_title}
                                        onChange={this.handleStatusChange}
                                    />           
                                </div>
                                <div className={style.form_item_group} >
                                  <label className={style.form_label} title="Renaming the title of order notes">
                                    {wp.i18n.__('Rename Order Notes Title')}                         
                                  </label>
                                  <input
                                    name={'order_Notes_Title'}
                                    type="text"
                                    value={this.state.order_Notes_Title}
                                    onChange={this.handleInput}
                                    placeholder="Enter the title"
                                    className={style.form_input}
                                  />          
                                </div>
                                <div  className={style.form_item_group} >
                                  <label className={style.form_label} title="Force to creating account for non logged users">
                                    {wp.i18n.__('Force Create Account')}          
                                  </label>
                                    <Toggle
                                        name={'force_create_Account'}
                                        icons={false}
                                        value={this.state.force_create_Account}
                                        checked={this.state.force_create_Account}
                                        onChange={this.handleStatusChange}
                                    />   
                                </div>
                                <div className={style.form_item_group}>
                                  <label className={style.form_label}  title="Removing privacy policy content from checkout page">
                                    {wp.i18n.__('Remove Privacy Policy Text')}
                                  
                                  </label>
                                  <Toggle
                                      name={'privacy_text'}
                                      icons={false}
                                      value={this.state.privacy_text}
                                      checked={this.state.privacy_text}
                                      onChange={this.handleStatusChange}
                                  /> 
                                </div>
                                <div className={style.form_item_group} >
                                  <label className={style.form_label}  title="Removing checkout coupon form">
                                    {wp.i18n.__('Remove Chekout Coupon Form')}
                                  
                                  </label>
                                  <Toggle
                                      name={'checkout_coupon_form'}
                                      icons={false}
                                      value={this.state.checkout_coupon_form}
                                      checked={this.state.checkout_coupon_form}
                                      onChange={this.handleStatusChange}
                                  /> 
                                </div> 
                                <div className={style.form_item_group}>
                                  <label className={style.form_label} title="Remove shipping to different address form from checkout">
                                    {wp.i18n.__('Remove Shipping Field')}
                                  
                                  </label>
                                  <Toggle
                                      name={'remove_shipping_field'}
                                      icons={false}
                                      value={this.state.remove_shipping_field}
                                      checked={this.state.remove_shipping_field}
                                      onChange={this.handleStatusChange}
                                  /> 
                                </div> 

                        <div className={style.form_item_group}>
                                <label className={style.form_label} title="Removing terms and conditions from checkout page">
                                  {wp.i18n.__('Remove Checkout Terms and Conditions')}
                                </label>
                                <Toggle
                                    name={'remove_terms_condition'}
                                    icons={false}
                                    value={this.state.remove_terms_condition}
                                    checked={this.state.remove_terms_condition}
                                    onChange={this.handleStatusChange}
                                /> 
                        </div> 

                                <div>
                                  <input
                                      type="button"
                                      value="Save"
                                      onClick ={this.handleFormSubmit}
                                      className={style.form_button}
                                  />
                                </div>
                                {!this.state.isHidden && <AWRPLoader />} 
                            </div>
                          </div>
                    </TabPanel>

                    <TabPanel className={style.right_tab} >
                     <div className={style.awcfe_field_group}>
                       <div className={style.text_group}>
                           <p className={style.sectionTitle}>{wp.i18n.__('Address formatting')}</p>
                           <p className={style.sectionDesc}> Customize default address formats and add our custom fields to address. To include a field into address area, select that field from the respective dropdown below and add field name in the following format <span className={style.highlight}>{'{field_name}'}</span> at Address format customize area. </p>
                       </div>

                       <div className={style.form_activation_group}>

                               <div className={style.form_item_group}>
                                 <label className={style.form_label}>{wp.i18n.__('Billing address fields')}</label>
                                 <ReactSelect
                                     className={style.form_select}
                                     options={extraFields_optionsBill}
                                     name="awcfe_addrextra_billing_fields"
                                     placeholder="Select"
                                     isMulti
                                     value={extraFields_optionsBill.filter(e => Array.isArray(this.state.awcfe_addrextra_billing_fields) ? this.state.awcfe_addrextra_billing_fields.indexOf(e.value) >= 0 : false)}
                                     onChange={this.handleChangeAddrExtraBill}
                                 />
                               </div>

                               <div className={style.form_item_group}>
                                 <label className={style.form_label}>{wp.i18n.__('Shipping address Fields')}</label>
                                 <ReactSelect
                                     className={style.form_select}
                                     options={extraFields_optionsShipp}
                                     name="awcfe_addrextra_shipping_fields"
                                     placeholder="Select"
                                     isMulti
                                     value={extraFields_optionsShipp.filter(e => Array.isArray(this.state.awcfe_addrextra_shipping_fields) ? this.state.awcfe_addrextra_shipping_fields.indexOf(e.value) >= 0 : false)}
                                     onChange={this.handleChangeAddrExtraShip}
                                 />
                               </div>

                             <div className={style.form_item_group}>
                               <label className={style.form_label}>{wp.i18n.__('Address format customize')}</label>

                               <textarea
                                 name ="awcfe_address_format_custom"
                                 value={this.state.awcfe_address_format_custom}
                                 onChange={this.handleInput}
                                 className={style.form_input}
                               />

                              <p className={style.addressFormatDesc} > To override default address formats, add values in the format given below. Address format is different for each country, so you can override address format for each country. Each country format should be separated by pipe( | ). No space is required.</p>
                              <p className={style.addressFormat} >{'US=>"{name}\\n{company}\\n{address_1}\\n{address_2}\\n{city}, {state_code} {postcode}\\n{country}"'}</p>
                             </div>

                             <div className={style.activate_license} >
                                 <input
                                     type="button"
                                     value="Save"
                                     onClick ={this.handleFormSubmit}
                                     className={style.form_button}
                                 />
                             </div>
                             {!this.state.isHidden && <AWRPLoader />}

                        </div>
                      </div>
                     </TabPanel>

                     <TabPanel className={style.right_tab} >
                      <div className={style.awcfe_field_group}>
                        <div className={style.text_group}>
                            <p className={style.sectionTitle}>{wp.i18n.__('PDF Invoices & Packing Slips')}</p>
                            <p className={style.sectionDesc}> Include your extra checkout fields in PDF Invoices & Packing Slips generated by <a href="https://acowebs.com/woocommerce-pdf-invoices-and-packing-slips/" target="_blank"> PDF Invoices and Packing Slips For WooCommerce PRO</a> (By Acowebs) </p>
                        </div>

                        <div className={style.form_activation_group}>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Enable PDF Invoice & Packing Slip support')}</label>

                              <Toggle
                                name={'awcfe_enable_aco_pdf_support'}
                                icons={false}
                                value={this.state.awcfe_enable_aco_pdf_support}
                                checked={this.state.awcfe_enable_aco_pdf_support}
                                onChange={this.handleStatusChange}
                              />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Invoice Fields')}</label>
                              <ReactSelect
                                  className={style.form_select}
                                  options={extraFields_optionsBS}
                                  name="awcfe_aco_pdf_invoice"
                                  placeholder="Select"
                                  isMulti
                                  value={extraFields_optionsBS.filter(e => Array.isArray(this.state.awcfe_aco_pdf_invoice) ? this.state.awcfe_aco_pdf_invoice.indexOf(e.value) >= 0 : false)}
                                  onChange={this.handleChangeAI}
                              />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Packing Slip Fields')}</label>
                              <ReactSelect
                                  className={style.form_select}
                                  options={extraFields_optionsBS}
                                  name="awcfe_aco_pdf_packing"
                                  placeholder="Select"
                                  isMulti
                                  value={extraFields_optionsBS.filter(e => Array.isArray(this.state.awcfe_aco_pdf_packing) ? this.state.awcfe_aco_pdf_packing.indexOf(e.value) >= 0 : false)}
                                  onChange={this.handleChangeAP}
                              />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Shipping label Fields')}</label>
                              <ReactSelect
                                  className={style.form_select}
                                  options={extraFields_optionsShipp}
                                  name="awcfe_aco_pdf_shipping"
                                  placeholder="Select"
                                  isMulti
                                  value={extraFields_optionsShipp.filter(e => Array.isArray(this.state.awcfe_aco_pdf_shipping) ? this.state.awcfe_aco_pdf_shipping.indexOf(e.value) >= 0 : false)}
                                  onChange={this.handleChangeAS}
                              />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Delivery Note Fields')}</label>
                              <ReactSelect
                                  className={style.form_select}
                                  options={extraFields_optionsBS}
                                  name="awcfe_aco_pdf_delivery"
                                  placeholder="Select"
                                  isMulti
                                  value={extraFields_optionsBS.filter(e => Array.isArray(this.state.awcfe_aco_pdf_delivery) ? this.state.awcfe_aco_pdf_delivery.indexOf(e.value) >= 0 : false)}
                                  onChange={this.handleChangeAD}
                              />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Dispatch Fields')}</label>
                              <ReactSelect
                                  className={style.form_select}
                                  options={extraFields_optionsBS}
                                  name="awcfe_aco_pdf_dispatch"
                                  placeholder="Select"
                                  isMulti
                                  value={extraFields_optionsBS.filter(e => Array.isArray(this.state.awcfe_aco_pdf_dispatch) ? this.state.awcfe_aco_pdf_dispatch.indexOf(e.value) >= 0 : false)}
                                  onChange={this.handleChangeADP}
                              />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Credit Note Fields')}</label>
                              <ReactSelect
                                  className={style.form_select}
                                  options={extraFields_optionsBS}
                                  name="awcfe_aco_pdf_credit"
                                  placeholder="Select"
                                  isMulti
                                  value={extraFields_optionsBS.filter(e => Array.isArray(this.state.awcfe_aco_pdf_credit) ? this.state.awcfe_aco_pdf_credit.indexOf(e.value) >= 0 : false)}
                                  onChange={this.handleChangeAC}
                              />
                            </div>

                            <div className={style.activate_license} >
                                <input
                                    type="button"
                                    value="Save"
                                    onClick ={this.handleFormSubmit}
                                    className={style.form_button}
                                />
                            </div>
                            {!this.state.isHidden && <AWRPLoader />}

                        </div>

                      </div>
                    </TabPanel>

                     <TabPanel className={style.right_tab} >
                      <div className={style.awcfe_field_group}>
                        <div className={style.text_group}>
                            <p className={style.sectionTitle}>{wp.i18n.__('PDF Invoices & Packing Slips')}</p>
                            <p className={style.sectionDesc}> Include your extra checkout fields in PDF Invoices & Packing Slips generated by <a href="https://wordpress.org/plugins/woocommerce-pdf-invoices-packing-slips/" target="_blank"> PDF Invoices & Packing Slips for WooCommerce plugin</a> (By WP Overnight) </p>
                        </div>

                        <div className={style.form_activation_group}>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Enable PDF Invoice & Packing Slip support')}</label>

                              <Toggle
                                name={'awcfe_enablet_pdf_ip_support'}
                                icons={false}
                                value={this.state.awcfe_enablet_pdf_ip_support}
                                checked={this.state.awcfe_enablet_pdf_ip_support}
                                onChange={this.handleStatusChange}
                              />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Invoice Fields')}</label>
                              <ReactSelect
                                  className={style.form_select}
                                  options={extraFields_options}
                                  name="awcfe_pdf_ip_invoice_fields"
                                  placeholder="Select"
                                  isMulti
                                  value={extraFields_options.filter(e => Array.isArray(this.state.awcfe_pdf_ip_invoice_fields) ? this.state.awcfe_pdf_ip_invoice_fields.indexOf(e.value) >= 0 : false)}
                                  onChange={this.handleChange}
                              />
                            </div>

                            <div className={style.form_item_group}>
                              <label className={style.form_label}>{wp.i18n.__('Packing Slip Fields')}</label>
                              <ReactSelect
                                  className={style.form_select}
                                  options={extraFields_options}
                                  name="awcfe_pdf_ip_packing_fields"
                                  placeholder="Select"
                                  isMulti
                                  value={extraFields_options.filter(e => Array.isArray(this.state.awcfe_pdf_ip_packing_fields) ? this.state.awcfe_pdf_ip_packing_fields.indexOf(e.value) >= 0 : false)}
                                  onChange={this.handleChangePacking}
                              />
                            </div>

                            <div className={style.activate_license} >
                                <input
                                    type="button"
                                    value="Save"
                                    onClick ={this.handleFormSubmit}
                                    className={style.form_button}
                                />
                            </div>
                            {!this.state.isHidden && <AWRPLoader />}

                        </div>

                      </div>
                    </TabPanel>


                    <TabPanel className={style.right_tab} >
                        <div className={style.awcfe_field_group}>
                            <div className={style.text_group}>
                                <p className={style.sectionTitle}>{wp.i18n.__('Plugin License')}</p>
                                <p className={style.awcfeStatus + ' '+ ((this.state.awcfe_activation_status === 'valid' || this.state.awcfe_activation_status === true) ? 'active' : '')}>
                                    {wp.i18n.__('Status:')} <span>{(this.state.awcfe_activation_status === 'valid' || this.state.awcfe_activation_status === true) ? wp.i18n.__('Active') : wp.i18n.__('Inactive')}</span>
                                </p>
                            </div>
                            <div className={style.form_activation_group}>
                                <label className={style.form_label}>{wp.i18n.__('License Key')}</label>
                                <input
                                    name ="awcfe_activation_license_key"
                                    type="text"
                                    value={this.state.awcfe_activation_license_key}
                                    onChange={this.handleInput}
                                    placeholder="Enter your license key here"
                                    className={style.form_input}
                                />
                                <div className={style.activate_license} >
                                    <input
                                        type="button"
                                        value="Activate"
                                        onClick ={this.handleActivation}
                                        // disabled={this.state.awcfe_activation_status == 'valid' ? 'disabled': ''}
                                        className={style.form_button}
                                    />
                                </div>

                                {!this.state.isHidden && <AWRPLoader />}

                                <p className={style.msgStatus + ' '+ ((this.state.awcfe_activation_status === 'valid' || this.state.awcfe_activation_status === true) ? 'active' : '')}>{this.state.activation_message ? this.state.activation_message : '' }</p>

                            </div>

                        </div>
                    </TabPanel>


                    


                </Tabs>


                </div>
                </div>

                <div className={style.right_sec}>

                    <div className={style.awcfe_content_right}>

                            <div className={style.awcfe_textbox}>
                                <h4>Dedicated Support</h4>
                                <p>Our support is what makes us No 1. We are available round the clock for any support</p>
                                { /* <a href="https://support.acowebs.com/support/acowebs/" target="_blank">Contact Support</a> */ }
                                <a href="https://support.acowebs.com/portal/newticket" target="_blank">Contact Support</a>
                            </div>
                            <div className={style.awcfe_textbox}>
                                <h4>Full Documentation</h4>
                                <p>Look for any helps in our documentation if you are stuck with anything</p>
                                <a href="https://acowebs.com/woocommerce-checkout-field-editor-and-manager/" target="_blank">Read More</a>
                            </div>

                    </div>

                </div>

                </div>
            </div>)
    }
}
